import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import {isIE, isChrome, browserVersion} from 'react-device-detect';
import moment from 'moment';
import 'moment/locale/es';

import Login from './Login/login';
import Home from './Dashboard/Home/home';
import NewTrip from './Dashboard/Trips/newTrip/index';
import NewInternalTrip from './Dashboard/InternalTrips/newTrip/index';
import Trip from './Dashboard/Home/Trip';
import Admin from './Dashboard/Admin/admin';
import ForgotPassword from './ForgotPassword/forgotPassword';
import PasswordReset from './PasswordReset/passwordReset';
import PageNotFound from '../components/PageNotFound/pageNotFound';
import BrowserCompatibility from '../components/BrowserCompatibility/browserCompatibility';
import Logout from './Logout/logout';
import ReportHome from './Dashboard/Reports/index';
import helpers from "../utils/helpers";

class App extends Component {

    constructor(props) {
        super(props);
        moment.locale('es');
    }

    render() {

        let browserVersionSplit = browserVersion.toString().split('.');
        let majorBrowserVersion = parseInt(browserVersionSplit[0], 10);

        if((isIE && majorBrowserVersion < 11) || (isChrome && majorBrowserVersion < 40)){
            return <BrowserCompatibility />;
        }

        if (this.props.user && this.props.user.username){

            if(this.props.user.needs_password_reset){
                return (
                    <Router>
                        <Switch>
                            <Route path="/logout" component={Logout}/>
                            <Route path='*' component={PasswordReset} />
                        </Switch>
                    </Router>
                );
            }

            return (
                <Router>
                    <Switch>
                        <Route exact path="/" component={Home}/>
                        <Route path="/internal-trips" render={(props) => (
                            <Home {...props} data={{trip_type: helpers.trip_type.INTERNAL}}/>
                        )}/>
                        <Route path="/trips/new-trip/:type" component={NewTrip}/>
                        <Route path="/trips/new-internal-trip" component={NewInternalTrip}/>
                        <Route path='/trips/:id' component={Trip}/>
                        <Route path='/reports' component={ReportHome}/>
                        <Route path='/admin' component={Admin}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path='/password-change' component={PasswordReset} />
                        <Route path='*' component={PageNotFound} />
                    </Switch>
                </Router>
            );
        }

        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={Login}/>
                    <Route path="/forgot-password" component={ForgotPassword}/>
                    <Route path="/logout" component={Logout}/>
                    <Route path='*' component={PageNotFound} />
                </Switch>
            </Router>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/app.js